module.exports = __webpack_public_path__ + "static/media/vhs2.8cd40ec2.jpeg";